// no-console is disabled for this file via the eslint flat config per-file
// override — see `eslint.config.mjs`. Centralized observability surface.
import * as Sentry from '@sentry/react'

import { env, isDev, isProd } from '~/env'
import { scrubSentryEvent } from './sentry-scrub'

/**
 * Initialize Sentry SPA. No-op when `VITE_SENTRY_DSN` is empty (dev default).
 *
 * - Scrubbing (see ./sentry-scrub.ts): events, transactions and breadcrumbs lose
 *   request headers/cookies/body, URL query strings and JWTs, and keep only the
 *   user id. We tag every event with the admin-dashboard release so SPA + API
 *   events correlate by request id.
 * - Tracing is enabled in prod only at 10% sample rate to keep cost low.
 * - Replay is disabled — admin tooling has too much sensitive data on
 *   screen to record sessions automatically.
 */
export function initSentry(): void {
  if (!env.VITE_SENTRY_DSN) return

  const release = env.VITE_SENTRY_RELEASE
  Sentry.init({
    dsn: env.VITE_SENTRY_DSN,
    environment: isProd ? 'production' : isDev ? 'development' : 'preview',
    tracesSampleRate: isProd ? 0.1 : 0,
    integrations: [Sentry.browserTracingIntegration()],
    beforeSend: (event) => scrubSentryEvent(event),
    beforeSendTransaction: (event) => scrubSentryEvent(event),
    beforeBreadcrumb: (breadcrumb) => scrubSentryEvent(breadcrumb),
    ...(release ? { release } : {}),
  })
}

export { Sentry }
